import { useEffect, useRef, useState } from 'react';
import HeroSlider from '../components/HeroSlider';
import ProductCard from '../components/ProductCard';
import { fetchSponsoredProducts } from '../api/products';
import { fetchHomeContent } from '../api/homeContent';

const Home = () => {
  const [sponsoredProducts, setSponsoredProducts] = useState([]);
  const [homeContent, setHomeContent] = useState({
    title: 'Dobro došli u Tajni prostor',
    text: 'Ako ste ljubitelj indijske i orijentalne kulture, ovo je pravo mesto za vas. Raspolažemo raznovrsnim proizvodima sa ovih podnevlja i verujemo da će svako naći po nešto za svoj ukus.',
  });

  const viewportRef = useRef(null);
  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(false);

  useEffect(() => {
    const loadSponsored = async () => {
      try {
        const data = await fetchSponsoredProducts();
        setSponsoredProducts(data || []);
      } catch (err) {
        console.error('Failed to fetch sponsored products:', err);
      }
    };

    const loadHomeContent = async () => {
      try {
        const data = await fetchHomeContent();
        if (data) {
          setHomeContent({
            title: data.title || 'Dobro došli u Tajni prostor',
            text: data.text || '',
          });
        }
      } catch (err) {
        console.error('Failed to fetch home content:', err);
      }
    };

    loadSponsored();
    loadHomeContent();
  }, []);

  const updateEdges = () => {
    const el = viewportRef.current;
    if (!el) return;
    const { scrollLeft, scrollWidth, clientWidth } = el;
    const epsilon = 2;
    setAtStart(scrollLeft <= epsilon);
    setAtEnd(scrollLeft + clientWidth >= scrollWidth - epsilon);
  };

  useEffect(() => {
    updateEdges();
    const el = viewportRef.current;
    if (!el) return;
    const onScroll = () => updateEdges();
    el.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', updateEdges);
    return () => {
      el.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', updateEdges);
    };
  }, [sponsoredProducts]);

  const scrollPrev = () => {
    const el = viewportRef.current;
    if (!el) return;
    el.scrollBy({ left: -el.clientWidth, behavior: 'smooth' });
  };

  const scrollNext = () => {
    const el = viewportRef.current;
    if (!el) return;
    el.scrollBy({ left: el.clientWidth, behavior: 'smooth' });
  };

  return (
    <div>
      <HeroSlider />

      <section className="py-10 px-6 mx-auto text-center">
        <h2 className="text-3xl text-[var(--text-color)] md:text-4xl font-bold mb-4">
          {homeContent.title}
        </h2>

        <div
          className="text-[var(--text-color)] text-lg leading-relaxed max-w-2xl mx-auto home-intro-content"
          dangerouslySetInnerHTML={{ __html: homeContent.text }}
        />
      </section>

      <section className="p-6 mx-auto pb-20 max-w-6xl relative">
        <h2 className="text-2xl font-bold mb-4 text-center">Najprodavaniji proizvodi</h2>

        {sponsoredProducts.length === 0 ? (
          <p className="text-gray-600 text-center">Nema najprodavanijih proizvoda</p>
        ) : (
          <div className="relative">
            {!atStart && (
              <button
                onClick={scrollPrev}
                className="hidden md:flex items-center justify-center absolute left-0 top-1/2 -translate-y-1/2 z-10
                           w-10 h-10 rounded-full bg-white/90 shadow hover:bg-white"
                aria-label="Previous"
              >
                ←
              </button>
            )}

            <div
              ref={viewportRef}
              className="overflow-x-auto overflow-y-hidden scroll-smooth no-scrollbar"
            >
              <div className="flex gap-6">
                {sponsoredProducts.map((product) => (
                  <ProductCard
                    key={product.id}
                    product={product}
                    classes={'flex-none w-full md:w-1/4'}
                  />
                ))}
              </div>
            </div>

            {!atEnd && (
              <button
                onClick={scrollNext}
                className="hidden md:flex items-center justify-center absolute right-0 top-1/2 -translate-y-1/2 z-10
                           w-10 h-10 rounded-full bg-white/90 shadow hover:bg-white"
                aria-label="Next"
              >
                →
              </button>
            )}
          </div>
        )}
      </section>
    </div>
  );
};

export default Home;